import React from 'react';
import TopNav from './TopNav';
import BottomNav from './BottomNav';

interface AppLayoutProps {
  children: React.ReactNode;
  activeRoute?: string;
  lang?: 'en' | 'ta';
  onLangToggle?: () => void;
}

export default function AppLayout({ children, activeRoute = '/', lang = 'en', onLangToggle }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <TopNav activeRoute={activeRoute} lang={lang} onLangToggle={onLangToggle} />
      <main className="flex-1 pb-24 md:pb-8 pt-16">
        {children}
      </main>
      <BottomNav activeRoute={activeRoute} lang={lang} />
    </div>
  );
}